import AvatarCluster from '../avatar/avatar-cluster';
import edap from '../collaborate/edap';
import React from 'react';

export const edapHandler = (boardId, listingId, func) => {
    return () => {
        func(boardId, listingId);
    };
};

export const getVoters = (votes = []) => {
    if (!Array.isArray(votes)) {
        return [];
    }
    return votes
        .filter((vote) => vote)
        .map((vote) => {
            return vote.voter;
        });
};

export const Voters = ({
    listingId,
    tripBoardUuid,
    votes
}) => {
    const profiles = getVoters(votes);
    return (
        <AvatarCluster
            className="voters"
            onClose={edapHandler(tripBoardUuid, listingId, edap.votersClose)}
            onOpen={edapHandler(tripBoardUuid, listingId, edap.votersOpen)}
            profiles={profiles}
            showAvatar
            sm
        />
    );
};

Voters.defaultProps = {
    votes: []
};

export default Voters;


// WEBPACK FOOTER //
// ./src/universal/tripboard/votes/voters.js